import { LogoMark } from "./Logo";

export const Marquee = ({ items, className = "" }) => {
  const row = [...items, ...items];
  return (
    <div data-testid="capabilities-marquee" className={`relative overflow-hidden border-y border-line bg-navy-900/60 py-5 ${className}`} aria-hidden="true">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-32 bg-gradient-to-r from-navy to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-32 bg-gradient-to-l from-navy to-transparent" />
      <div className="flex w-max animate-marquee items-center gap-12 will-change-transform">
        {row.map((t, i) => (
          <div key={i} className="flex items-center gap-12">
            <span className="whitespace-nowrap font-heading text-lg font-medium tracking-tight text-slate-300 md:text-xl">{t}</span>
            <LogoMark className="h-4 w-4 opacity-70" />
          </div>
        ))}
      </div>
    </div>
  );
};
